<template>
   <div class="mt-10 bg-gray-200 p-4 rounded-lg shadow-md flex flex-col">
      <h2 class="col-span-4 xs:col-span-3">
         {{
            guestIndex === 0
               ? 'Primary guest information'
               : 'Guest ' + guestIndex + ' information'
         }}
      </h2>
      <div class="flex-col space-y-4 mt-4">
         <div class="flex flex-col lg:flex-row space-x-0 space-y-3 lg:space-y-0 lg:space-x-3">
            <div class="grow flex flex-col space-y-1">
               <InputLabel
                  class="required"
                  for="name"
                  :value="$t('contact.name')"
               />
               <InputText
                  id="name"
                  type="text"
                  size="small"
                  class="w-full"
                  v-model="model.first_name"
                  required
                  autocomplete="off"
                  autofocus
               />
               <InputError
                  :message="
                     isArray(errors[`guests.${guestIndex}.first_name`])
                        ? errors[`guests.${guestIndex}.first_name`][0]
                        : errors[`guests.${guestIndex}.first_name`]
                  "
               />
            </div>
            <div class="grow flex flex-col space-y-1">
               <InputLabel
                  class="required"
                  for="name"
                  :value="$t('contact.last_name')"
               />
               <InputText
                  size="small"
                  id="name"
                  type="text"
                  class="w-full"
                  v-model="model.last_name"
                  required
                  autocomplete="off"
                  autofocus
               />
               <InputError
                  :message="
                     isArray(errors[`guests.${guestIndex}.last_name`])
                        ? errors[`guests.${guestIndex}.last_name`][0]
                        : errors[`guests.${guestIndex}.last_name`]
                  "
               />
            </div>
         </div>
         <div class="grow flex flex-col space-y-1">
            <InputLabel
               for="email"
               :value="$t('contact.email')"
            />
            <InputText

               size="small"
               id="email"
               type="text"
               class="w-full"
               v-model="model.email"
               required
               autocomplete="off"
               autofocus
            />
            <InputError
               :message="
                  isArray(errors[`guests.${guestIndex}.email`])
                     ? errors[`guests.${guestIndex}.email`][0]
                     : errors[`guests.${guestIndex}.email`]
               "
            />
         </div>
         <div class="flex flex-col lg:flex-row space-x-0 space-y-3 lg:space-y-0 lg:space-x-3">
            <div class="grow flex flex-col space-y-1">
               <InputLabel
                  class="required"
                  :value="$t('contact.dob')"
               />
               <DatePicker
                  v-model="model.date_of_birth"
                  size="small"
                  class="w-full"
                  show-icon
                  date-format="dd-mm-yy"
                  :max-date="new Date()"
                  icon-display="input"
               />
               <InputError
                  :message="
                     isArray(errors[`guests.${guestIndex}.date_of_birth`])
                        ? errors[`guests.${guestIndex}.date_of_birth`][0]
                        : errors[`guests.${guestIndex}.date_of_birth`]
                  "
               />
            </div>
            <div class="grow flex flex-col space-y-1">
               <InputLabel
                  class="required"
                  for="phone_number"
                  :value="$t('contact.phone_number')"
               />

               <PhoneInput
                  v-model="model.phone_number"
               />

               <InputError
                  :message="
                     isArray(errors[`guests.${guestIndex}.phone_number`])
                        ? errors[`guests.${guestIndex}.phone_number`][0]
                        : errors[`guests.${guestIndex}.phone_number`]
                  "
               />
            </div>
         </div>
      </div>
   </div>
</template>

<script setup>
   import InputLabel from '@/Components/Forms/InputLabel.vue';
   import { DatePicker, InputText } from 'primevue';
   import InputError from '@/Components/Forms/InputError.vue';
   import { defineEmits, defineModel } from 'vue';
   import { isArray } from 'lodash';
   import PhoneInput from '@/Components/Forms/PhoneInput.vue';

   defineProps({
      errors: Object,
      guestIndex: Number,
   });

   const model = defineModel({
      set(value) {
         const dateOfBirth = value.date_of_birth;
      },
      type: Object,
      required: true,
   });


   const emit = defineEmits(['removeGuest']);
</script>

<style scoped></style>
